import * as types from "./actionTypes";
import { openBackdropOverlay, closeBackDropOverlay } from "./apiStatusActions";

export function dispatchActionData(type, data) {
  return { type: type, data: data };
}

//to set steps array list
export function setSteps(data) {
  return function (dispatch) {
    dispatch(dispatchActionData(types.SET_STEPPER_STEPS, data));
  };
}
// to set the active step count
export function setActiveStep(data) {
  return function (dispatch) {
    dispatch(openBackdropOverlay());
    dispatch(dispatchActionData(types.SET_STEPPER_ACTIVE_STEP, data));
    dispatch(closeBackDropOverlay());
  };
}
